module.exports = __webpack_public_path__ + "static/media/ContrastBadOptimized.078f2f2f.webp";